import { ArrowRight } from "lucide-react";
import { TemplateBar } from "./TemplateBar";

const input = "mt-1 w-full rounded-xl border border-zinc-300 px-3 py-2.5 text-base focus:outline-none focus:border-orange-500";

export const RouteSetup = ({ draft, setDraft, save, templateBarProps, onNext }) => (
  <section data-testid="loading-setup" className="space-y-3">
    <p className="text-xs font-bold uppercase tracking-widest text-orange-700">Krok 1 z 2 · Trasa</p>
    <div className="rounded-2xl bg-white ring-1 ring-zinc-200 p-4 space-y-3">
      <label className="block text-xs font-semibold text-zinc-700">Nazwa trasy<input data-testid="loading-route-name" value={draft.name} maxLength={120} placeholder="np. Rej 16 · rano" onChange={(e) => setDraft({ ...draft, name: e.target.value })} onBlur={() => save(draft)} className={input} /></label>
      <label className="block text-xs font-semibold text-zinc-700">Miasto<input data-testid="loading-city" value={draft.city} maxLength={80} onChange={(e) => setDraft({ ...draft, city: e.target.value })} onBlur={() => save(draft)} className={input} /></label>
    </div>
    <TemplateBar {...templateBarProps} />
    <button type="button" data-testid="loading-setup-next" onClick={onNext} className="w-full h-12 inline-flex items-center justify-center gap-2 rounded-2xl bg-orange-600 text-white text-sm font-black uppercase tracking-wider hover:bg-orange-700 active:scale-[0.98] transition-[background-color,transform]">
      Dalej: wpisuj paczki<ArrowRight className="w-4 h-4" />
    </button>
  </section>
);
